import {
    useMutation,
} from '@tanstack/react-query'

import simpleApi from 'app/services/simpleApi'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import requests from 'app/requests/Quote/Quote.requests'
import {
    RequestDataUpdate,
} from '../../AQuotes.types'

const useAQuoteUpdate = (onSuccess: () => void) => {
    const token = useJWTToken()

    const {
        onSuccess: onSuccessUpdateAQuote,
        onError,
    } = useHandleStatusRequest({
        title: 'A-Quote was updated',
        id: 'AQuoteUpdated',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            data, id,
        }: {data: RequestDataUpdate, id: number}) => {
            return simpleApi({
                ...requests.updateRequestedLane({
                    data,
                    id,
                }),
                token,
            })
        },
        onError,
        onSuccess: onSuccessUpdateAQuote,
    })
}

export default useAQuoteUpdate
